import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'; // Adicione Router, ActivatedRouteSnapshot, RouterStateSnapshot
import { inject, PLATFORM_ID } from '@angular/core'; // Importe PLATFORM_ID
import { isPlatformBrowser } from '@angular/common'; // Importe isPlatformBrowser
import { KeycloakService, } from 'keycloak-angular';
import { environment } from '../../environments/environment';
import { MobileTokenService } from './mobile-token';

export const authGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const platformId = inject(PLATFORM_ID);
  const isBrowser = isPlatformBrowser(platformId);
  const kc = inject(KeycloakService);
  const router = inject(Router); // Injetar o Router para navegação interna
  const mobileToken = inject(MobileTokenService);

  // 1. Evitar rodar no servidor (SSR)
  if (!isBrowser) {
    return true;
  }

  // ============================================
  // Verificar se é WebView Flutter
  // ============================================
  const isFlutterWebView = (globalThis.window as any).isFlutterWebView === true;
  const isFlutterAuthenticated = (globalThis.window as any).flutter_authenticated === true;
  //Se é WebView Flutter e já autenticou, retorna true direto
  if (isFlutterWebView && isFlutterAuthenticated) {
    return true;
  }

  //Se é WebView Flutter mas não tem token, bloqueia
  if (isFlutterWebView && !isFlutterAuthenticated) {
    await router.navigate(['/recadastramento'], { replaceUrl: true });
    return false;
  }

  // ============================================
  // Lógica de autenticação e autorização (NAVEGADOR/WEB NORMAL)
  // ============================================
  try {
    let authenticated = false;
    if (mobileToken.isMobile()) {
      authenticated = true;
    } else {
      authenticated = await kc.isLoggedIn();
    }

    if (!authenticated) {
      await kc.login({
        redirectUri: globalThis.window.location.origin + state.url,
      });
      return false; // Bloqueia o acesso à rota até o login.
    }

    // Verifica as roles/permissões
    const requiredRole = 'Recadastramento';
    const hasRole = kc.isUserInRole(requiredRole, environment.CLIENT_ID);
    if (!hasRole) {
      globalThis.window.location.href = environment.URL_GESTAO_FROTAS;
      return false;
    }
    return true;
  } catch (error) {
    console.error('Erro durante a autenticação:', error);
    await router.navigate(['/erro-autenticacao'], { replaceUrl: true });
    return false;
  }
};
